import React, { useEffect } from 'react';
import './App.css';
import MainHome from './route/mainAppRoute'

import { BrowserRouter as Router} from 'react-router-dom'
import InitializeDatadogRum from './datadog';
import { connect } from "react-redux";
import { fetchUserDetails } from "./services/service";
import { updateUserDetails } from "./store/actions";


function App() {

  
  useEffect(() => {
    InitializeDatadogRum();   
  }, []);

  return (
    <Router>
      <MainHome />
    </Router>
  );
}

export default App;




